import axios from 'axios'
import { ENV_CONFIG } from '../../utils/env'

// Axios instance KHÔNG có request/response interceptor — dùng riêng cho các call
// không được phép rơi vào vòng lặp refresh (vd: chính refresh-token call).
const httpBare = axios.create({
  baseURL: ENV_CONFIG.VITE_BACKEND_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default httpBare
